<template>
	<div>
		<van-sticky>
		<van-tabs v-model="active" @click="onClick"  swipeable title-active-color="#fab13e" color="#fab13e">
		  <van-tab v-for="(item,index) in menu" :name="item" :key="index" :title="item"></van-tab>
		</van-tabs>
		</van-sticky>
		
		<div v-if="active=='组织关系'" class="">
			<taskRelationship :camp_id="camp_id" :user_id="user_id" :type="type"></taskRelationship>
		</div>
		<div v-else-if="active=='管理任务'" class="">
			<managementTask :camp_id="camp_id" :user_id="user_id" :type="type"></managementTask>
		</div>
	</div>
</template>

<script>
	import managementTask from '../../publicComponents/managementTask';
	import taskRelationship from '../../publicComponents/taskRelationship';
	export default{
		components: {
			"managementTask":managementTask,
			taskRelationship
		},
		data(){
			return{
				active:'',
				menu:['组织关系','管理任务'],
				camp_id:'',
				user_id:'',
				type:'',
			}
		},
		created(){
			const that=this;
			that.camp_id=this.$route.query.camp_id;
			that.user_id=this.$route.query.user_id;
			that.type=this.$route.query.type;
			if(this.$route.query.tab){
			  that.active=this.$route.query.tab;
			}else{
			  that.active='组织关系';
			};
		},
		activated(){
			const that=this;
			that.camp_id=this.$route.query.camp_id;
			that.user_id=this.$route.query.user_id;
			that.type=this.$route.query.type;
			if(this.$route.query.tab){
			  that.active=this.$route.query.tab;
			}else{
			  that.active='组织关系';
			};
		},
		methods:{
			onClick(name){
				 let query='camp_id='+this.camp_id+'&user_id='+this.user_id+'&type='+this.type+'&tab='+name;
				 this.$router.replace('/subPackages/myTask/taskRelationshipVip?'+query);
			},
			
		},
		}
</script>

<style>
</style>
